import Index from "../../pages/snail/triennial/index";
import Game from "../../pages/snail/triennial/game";
import Test from "../../pages/snail/triennial/test";

const base = "triennial";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/game*`,
    name: `${base}-game`,
    component: Game
  },
  {
    path: `/${base}/test*`,
    name: `${base}-test`,
    component: Test
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/triennial.js